<template>
  <w-setting-sliding-popup ref="slidingPopup" title="장비 계정 엑셀 입력" width="750px">
    <div slot="content">
      <el-form :model="formData" ref="formData">
        <el-row style="padding-bottom: 10px;">
          <span style="font-size: 16px;">엑셀 파일 등록</span>
          <span style="color: #47C7B8; padding-left: 25px;">(파일의 내용이 템플릿에 맞지 않는 경우, 정보가 정상적으로 등록되지 않습니다.)</span>
        </el-row>
        <el-input disabled style="width: 85%; float: left; margin-right: 5px;" v-model="fileList.name"></el-input>
        <el-upload action="" :auto-upload="false" :show-file-list="false" :before-upload="(file) => file"
          accept :on-change="changeUploadFile" ref="reportUpload">
          <el-button type="primary" size="medium" style="margin-right: 5px; width: 100%;">파일업로드</el-button>
        </el-upload>
        <el-row style="padding-top: 5px;">
          <el-button size="mini" type="solid" @click="onDownloadExcelTemlate"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀 템플릿 다운로드</el-button>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="btn-group-center">
      <el-button size="large" type="solid" @click="onClickExcelImport" :disabled="!disabledFlag">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import NetdeviceAccountSettingsAPI from '@/api/settings/netdevice/netdevice-account-settings';
import msgUtil from '@/utils/message';

export default {
  name: 'WImportExcelSyncSlidingPopup',
  data() {
    return {
      fileList: {},
      disabledFlag: false,
      formData: {},
    };
  },
  methods: {
    // 엑셀 템플릿 다운로드
    onDownloadExcelTemlate() {
      NetdeviceAccountSettingsAPI.downloadNetdeviceAccountTemplate();
    },
    open() {
      this.fileList = {};
      this.disabledFlag = false;
      this.$refs.slidingPopup.open();
    },
    changeUploadFile(item) {
      this.fileList = item.raw;
      this.disabledFlag = true;
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    onClickExcelImport() {
      const data = new FormData();
      if (this.fileList.uid) {
        data.append('files', this.fileList);
      }
      // 엑셀 입력
      NetdeviceAccountSettingsAPI.importDeviceSync(data).then((res) => {
        if (res.data.success) {
          this.$emit('load-data');
          this.clickCloseBtn();
          const resultData = res.data.data;
          let message = '';
          if (resultData.failCnt === 0) {
            message = `${resultData.totalCnt}개의 장비 계정 정보를 수정하였습니다.`;
          } else {
            message = `${resultData.totalCnt}개의 장비 계정 정보를 수정하였습니다. 실패(${resultData.failCnt}/${resultData.totalCnt})`;
          }
          this.$message(msgUtil.getCustomResultMsgData(message, true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '엑셀 입력', false));
        }
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceAccountSettings/AccountSynchronization/popup/ImportExcelSyncSlidingPopup.vue